<script>
import './style.less';
export default {
  name: 'FtIcon',
  data() {
    return {};
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    tag: {
      type: [String, Number],
      default: null
    }
  },
  methods: {
    filter(val) {
      if (val >= 10000) {
        val = Math.round((val / 10000) * 100) / 100 + '万';
      } {
        return val;
      }
      // if (val >= 10000) {
      //   val = Math.round((val / 10000) * 100) / 100 + 'w';
      // } else if (val >= 1000) {
      //   val = Math.round((val / 1000) * 100) / 100 + 'k';
      // } else {
      //   return val;
      // }
      // return val;
    },
    renderSlot(name) {
      let slot = this.$scopedSlots[name] && this.$scopedSlots[name]({ data: this.$data });
      if (name === 'tag') {
        return this.tag ? (
          <van-tag round type="danger">
            {this.filter(this.tag)}
          </van-tag>
        ) : null;
      } else {
        return slot;
      }
    },
    renderBox() {
      return (
        <div class="fticon" {...{ on: { ...this.$listeners } }}>
          {this.renderSlot('tag')}
          {this.renderSlot('default')}
          {this.icon ? <i class={`iconfont ${this.icon}`}></i> : null}
        </div>
      );
    }
  },
  render() {
    return this.renderBox();
  }
};
</script>
